import React from 'react';
export function ExpertAdvice() {
  const articles = [{
    title: 'Choosing the Right Dog Food for Your Breed',
    category: 'Pet Care',
    readTime: '5 min read',
    image: 'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=600&q=80',
    badgeColor: 'badge-blue'
  }, {
    title: 'Getting Your Garden Summer-Ready',
    category: 'Garden Tips',
    readTime: '4 min read',
    image: 'https://images.unsplash.com/photo-1591857177580-dc82b9ac4e1e?w=600&q=80',
    badgeColor: 'badge-green'
  }, {
    title: 'Pool Maintenance Made Simple',
    category: 'Pool Care',
    readTime: '6 min read',
    image: 'https://cdn.magicpatterns.com/uploads/gJieNaGpPTNuQ4dJHRdHbU/Better_pets_pool_maintenance.jpg',
    badgeColor: 'badge-blue'
  }, {
    title: 'Setting Up Your First Aquarium',
    category: 'Fish & Aquatics',
    readTime: '7 min read',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600&q=80',
    badgeColor: 'badge-blue'
  }];
  return <section className="section-padding bg-white" data-id="element-82">
      <div className="container-wide" data-id="element-83">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4" data-id="element-84">
          <div className="max-w-2xl" data-id="element-85">
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-gray-900 mb-4" data-id="element-86">
              Expert Advice & Tips
            </h2>
            <p className="text-lg text-gray-600" data-id="element-87">
              Helpful guides from our team of local experts.
            </p>
          </div>
          <button className="text-brand-blue font-heading font-bold hover:text-brand-blue-700 transition-colors flex items-center gap-2 group" data-id="element-88">
            Browse All Advice
            <span className="transform group-hover:translate-x-1 transition-transform" data-id="element-89">
              →
            </span>
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-90">
          {articles.map((article, index) => <div key={index} className="card-interactive flex flex-col overflow-hidden cursor-pointer group border border-gray-100" data-id="element-91">
              <div className="h-48 relative overflow-hidden" data-id="element-92">
                <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105" style={{
              backgroundImage: `url(${article.image})`
            }} data-id="element-93"></div>
              </div>
              <div className="p-6 flex flex-col flex-grow bg-white" data-id="element-94">
                <div className="flex justify-between items-center mb-3" data-id="element-95">
                  <span className={`${article.badgeColor} bg-white shadow-sm`} data-id="element-96">
                    {article.category}
                  </span>
                  <span className="text-xs text-gray-500 font-medium" data-id="element-97">
                    {article.readTime}
                  </span>
                </div>
                <h3 className="font-heading font-bold text-lg text-gray-900 mb-4 line-clamp-2 flex-grow group-hover:text-brand-blue transition-colors" data-id="element-98">
                  {article.title}
                </h3>
                <div className="text-sm font-bold text-brand-blue flex items-center gap-1 mt-auto" data-id="element-99">
                  Read More{' '}
                  <span className="transform group-hover:translate-x-1 transition-transform" data-id="element-100">
                    →
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}